//set active section key detail
export const setShowMoreSectionKey = (value) => {
  return { type: "SHOW_MORE_SECTION", payload: value };
};

//set active section key detail
export const setEditPanel = (value) => {
  return { type: "SET_ON_EDIT_PANEL", payload: value };
};

//set active section key detail
export const setOnWidgetEdit = (value) => {
  return { type: "SET_ON_WIDGET_EDIT", payload: value };
};

//set active section key detail
export const setSectionOffset = (value) => {
  return { type: "SET_SECTION_OFFSET", payload: value };
};

export const setSharableData = (value) => {
  return { type: "SET_SHAREABLE_DATA", payload: value };
};
export const setScrollViewref = (value) => {
  return { type: "SET_SCROLL_VIEW", payload: value };
};
export const setWidgetArray = (value) => {
  return { type: "SET_WIDGET_ARRAY", payload: value };
};
export const setWidgetDiv = (value) => {
  return { type: "SET_WIDGET_DIV", payload: value };
};
export const setChartFlag = (value) => {
  return { type: "SET_CHART_FLAG", payload: value };
};

export const setVisitedWidgetId = (value) => {
  return { type: "SET_VISITED_WIDGET_ID", payload: value };
};
export const setGlobalSelectedWidgetId = (value) => {
  return { type: "SET_GLOBAL_SELECTED_WIDGET_ID", payload: value };
};
export const setRealtimeFinalFilters = (
  value,
  realtimeFinalFilters,
  idContainer
) => {
  let updatedWidgetId =
    idContainer?.widget_id + "#" + idContainer?.widget_index;
  let updatedFinalFilterValue = { ...realtimeFinalFilters };
  if (!updatedFinalFilterValue?.[idContainer?.template_id]) {
    updatedFinalFilterValue[idContainer?.template_id] = {
      [idContainer?.section_id]: {
        [updatedWidgetId]: value,
      },
    };
  } else {
    if (
      !updatedFinalFilterValue?.[idContainer?.template_id]?.[
        idContainer?.section_id
      ]
    ) {
      updatedFinalFilterValue[idContainer?.template_id][
        idContainer?.section_id
      ] = {
        [updatedWidgetId]: value,
      };
    } else {
      if (
        !updatedFinalFilterValue?.[idContainer?.template_id]?.[
          idContainer?.section_id
        ]?.[updatedWidgetId]
      ) {
        updatedFinalFilterValue[idContainer?.template_id][
          idContainer?.section_id
        ][updatedWidgetId] = value;
      } else {
        if (
          updatedFinalFilterValue?.[idContainer?.template_id]?.[
            idContainer?.section_id
          ]?.[updatedWidgetId]
        ) {
          updatedFinalFilterValue[idContainer?.template_id][
            idContainer?.section_id
          ][updatedWidgetId] = value;
        }
      }
    }
  }
  return {
    type: "SET_REALTIME_FINAL_FILTERS",
    payload: updatedFinalFilterValue,
  };
};
export const clearRealtimeFinalFilters = (
  value,
  realtimeFinalFilters,
  idContainer
) => {
  let updatedWidgetId =
    idContainer?.widget_id + "#" + idContainer?.widget_index;
  let updatedFinalFilterValue = { ...realtimeFinalFilters };
  if (
    updatedFinalFilterValue?.[idContainer?.template_id]?.[
      idContainer?.section_id
    ]?.[updatedWidgetId]
  ) {
    delete updatedFinalFilterValue?.[idContainer?.template_id]?.[
      idContainer?.section_id
    ]?.[updatedWidgetId];
  } else if (updatedFinalFilterValue?.[idContainer?.template_id]) {
    delete updatedFinalFilterValue[idContainer?.template_id];
  }
  return {
    type: "SET_REALTIME_FINAL_FILTERS",
    payload: updatedFinalFilterValue,
  };
};
export const setRealtimeFiltersObj = (
  value,
  realtimeFiltersObj,
  idContainer
) => {
  let updatedWidgetId =
    idContainer?.widget_id + "#" + idContainer?.widget_index;
  let updatedFilterObjValue = { ...realtimeFiltersObj };
  if (!updatedFilterObjValue?.[idContainer?.template_id]) {
    updatedFilterObjValue[idContainer?.template_id] = {
      [idContainer?.section_id]: {
        [updatedWidgetId]: value,
      },
    };
  } else {
    if (
      !updatedFilterObjValue?.[idContainer?.template_id]?.[
        idContainer?.section_id
      ]
    ) {
      updatedFilterObjValue[idContainer?.template_id][idContainer?.section_id] =
        {
          [updatedWidgetId]: value,
        };
    } else {
      if (
        !updatedFilterObjValue?.[idContainer?.template_id]?.[
          idContainer?.section_id
        ]?.[updatedWidgetId]
      ) {
        updatedFilterObjValue[idContainer?.template_id][
          idContainer?.section_id
        ][updatedWidgetId] = value;
      } else {
        if (
          updatedFilterObjValue?.[idContainer?.template_id]?.[
            idContainer?.section_id
          ]?.[updatedWidgetId]
        ) {
          updatedFilterObjValue[idContainer?.template_id][
            idContainer?.section_id
          ][updatedWidgetId] = value;
        }
      }
    }
  }
  return { type: "SET_REALTIME_FILTER_OBJ", payload: updatedFilterObjValue };
};
export const clearRealtimeFiltersObj = (
  value,
  realtimeFiltersObj,
  idContainer
) => {
  let updatedWidgetId =
    idContainer?.widget_id + "#" + idContainer?.widget_index;
  let updatedFilterObjValue = { ...realtimeFiltersObj };
  if (
    updatedFilterObjValue?.[idContainer?.template_id]?.[
      idContainer?.section_id
    ]?.[updatedWidgetId]
  ) {
    delete updatedFilterObjValue?.[idContainer?.template_id]?.[
      idContainer?.section_id
    ]?.[updatedWidgetId];
  } else if (updatedFilterObjValue?.[idContainer?.template_id]) {
    delete updatedFilterObjValue[idContainer?.template_id];
  }
  return { type: "SET_REALTIME_FILTER_OBJ", payload: updatedFilterObjValue };
};
export const setTextWidgetPopupVisible = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_TEXT_WIDGET_POPUP_VISIBLE", payload: value });
  };
};
export const setTextWidgetObject = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_TEXT_WIDGET_OBJECT", payload: value });
  };
};
